<!-- src/app/component/wizard-modal/wizard-modal.component.html -->
<div class="modal-backdrop" aria-modal="true" role="dialog" (click)="onBackdrop()">
  <div class="modal" [formGroup]="form" (click)="$event.stopPropagation()" tabindex="-1">
    <header class="modal-header">
      <div class="title">
        <img src="../../../assets/IconORA.svg" alt="" class="ico" />
        <h3>{{ 'componentsWizard.wizardV1.title' | translate }}</h3>
        <!-- Compteur seulement pour 1..4 -->
        <span class="step" *ngIf="step >= 1 && step <= 4">{{ 'componentsWizard.wizardV1.stepLabel' | translate: { step: step } }}</span>
      </div>
      <button type="button" class="x" (click)="onCancel()" [attr.aria-label]="'componentsWizard.wizardV1.close' | translate">✕</button>
    </header>

    <section class="modal-body" *ngIf="!loading; else loadingTpl">
      <!-- Accueil -->
      <ng-container *ngIf="step === 0">
        <div class="welcome">
          <p>{{ 'componentsWizard.wizardV1.welcome' | translate }}</p>
        </div>
      </ng-container>

      <!-- Étape 1 -->
      <ng-container *ngIf="step === 1">
        <label>{{ 'componentsWizard.wizardV1.step1.avgWeekday' | translate }}</label>
        <input type="number" formControlName="avg_weekday" />

        <label>{{ 'componentsWizard.wizardV1.step1.avgWeekend' | translate }}</label>
        <input type="number" formControlName="avg_weekend" />

        <label>{{ 'componentsWizard.wizardV1.step1.shareAppointments' | translate }}</label>
        <div class="input-suffix">
          <input
            type="number"
            formControlName="share_appointments_pct"
            min="0" max="100" step="1"
            inputmode="decimal"
            (blur)="normalizePct('share_appointments_pct')"
          />
          <span>%</span>
        </div>
      </ng-container>

      <!-- Étape 2 -->
      <ng-container *ngIf="step === 2">
        <label>{{ 'componentsWizard.wizardV1.step2.normalDays' | translate }}</label>
        <div class="days-chips" formArrayName="normal_days">
          <button
            type="button"
            class="chip-toggle"
            *ngFor="let c of normalDays.controls; let i = index"
            [class.active]="c.value"
            (click)="selectDayType('normal', i)"
          >
            {{ dayLabel(i) }}
          </button>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step2.highDays' | translate }}</label>
        <div class="days-chips" formArrayName="high_days">
          <button
            type="button"
            class="chip-toggle"
            *ngFor="let c of highDays.controls; let i = index"
            [class.active]="c.value"
            (click)="selectDayType('high', i)"
          >
            {{ dayLabel(i) }}
          </button>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step2.lowDays' | translate }}</label>
        <div class="days-chips" formArrayName="low_days">
          <button
            type="button"
            class="chip-toggle"
            *ngFor="let c of lowDays.controls; let i = index"
            [class.active]="c.value"
            (click)="selectDayType('low', i)"
          >
            {{ dayLabel(i) }}
          </button>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step2.difficultCasesShare' | translate }}</label>
        <div class="input-suffix">
          <input
            type="number"
            formControlName="difficult_cases_share_pct"
            min="0" max="100" step="1"
            inputmode="decimal"
            (blur)="normalizePct('difficult_cases_share_pct')"
          />
          <span>%</span>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step2.emergenciesPerDay' | translate }}</label>
        <input type="number" formControlName="emergencies_per_day" />
      </ng-container>

      <!-- Étape 3 : créneaux de pic (sans staff ici) -->
      <ng-container *ngIf="step === 3">
        <label>{{ 'componentsWizard.wizardV1.step3.peakWindowsLabel' | translate }}</label>
        <div formArrayName="peak_windows">
          <div class="peaks" *ngFor="let g of peakWindows.controls; let i = index" [formGroupName]="i">
            <select formControlName="from">
              <option *ngFor="let h of ['07:00','07:30','08:00','08:30','09:00','09:30','17:00','17:30','18:00','18:30']" [value]="h">{{ h }}</option>
            </select>
            <span>{{ 'componentsWizard.wizardV1.step3.to' | translate }}</span>
            <select formControlName="to">
              <option *ngFor="let h of ['07:30','08:00','08:30','09:00','09:30','10:00','17:30','18:00','18:30','19:00']" [value]="h">{{ h }}</option>
            </select>
            <button type="button" class="add" (click)="addPeakWindow()">＋</button>
            <button type="button" class="del" (click)="removePeakWindow(i)" [disabled]="peakWindows.length <= 1">－</button>
          </div>
        </div>
      </ng-container>

      <!-- Étape 4 : paramètres service + staff par pic -->
      <ng-container *ngIf="step === 4">
        <label>{{ 'componentsWizard.wizardV1.step4.simpleMin' | translate }}</label>
        <div class="input-suffix">
          <input type="number" formControlName="simple_min" min="1" />
          <span>min</span>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step4.complexMin' | translate }}</label>
        <div class="input-suffix">
          <input type="number" formControlName="complex_min" min="2" />
          <span>min</span>
        </div>

        <label>{{ 'componentsWizard.wizardV1.step4.rooms' | translate }}</label>
        <input type="number" formControlName="rooms" min="1" />

        <label>{{ 'componentsWizard.wizardV1.step4.staffDefault' | translate }}</label>
        <input type="number" formControlName="staff_default" min="1" />

        <!-- Reprise des pics saisis + saisie staff par créneau -->
        <div *ngIf="peakWindows.length > 0" style="margin-top:12px">
          <label>{{ 'componentsWizard.wizardV1.step4.peakStaffLabel' | translate }}</label>
          <div formArrayName="peak_windows">
            <div class="peaks" *ngFor="let g of peakWindows.controls; let i = index" [formGroupName]="i">
              <div style="min-width:160px">
                <strong>{{ g.controls['from'].value || '—' }}</strong>
                <span>→</span>
                <strong>{{ g.controls['to'].value || '—' }}</strong>
              </div>
              <div class="input-suffix" style="margin-left:auto">
                <input type="number" formControlName="staff" min="1" />
                <span>{{ 'componentsWizard.wizardV1.step4.staffUnit' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Page de fin -->
      <ng-container *ngIf="step === 5">
        <div class="finish">
          <p>
            {{ 'componentsWizard.wizardV1.finish.line1' | translate }}<br />
            {{ 'componentsWizard.wizardV1.finish.line2' | translate }}
          </p>
        </div>
      </ng-container>
    </section>

    <ng-template #loadingTpl>
      <div class="loading">{{ 'componentsWizard.wizardV1.loading' | translate }}</div>
    </ng-template>

    <footer class="modal-footer">
      <button type="button" class="ghost" *ngIf="step < 4"(click)="onCancel()">{{ 'componentsWizard.wizardV1.footer.cancel' | translate }}</button>
      <div class="spacer"></div>

      <!-- Accueil -->
      <button type="button" class="primary" *ngIf="step === 0" (click)="start()">{{ 'componentsWizard.wizardV1.footer.start' | translate }}</button>

      <!-- Étapes 1..4 -->
      <ng-container *ngIf="step >= 1 && step <= 4">
        <button type="button" class="prev" *ngIf="step > 1" (click)="prev()">{{ 'componentsWizard.wizardV1.footer.prev' | translate }}</button>
        <button type="button" class="next" *ngIf="step < 4" (click)="next()">{{ 'componentsWizard.wizardV1.footer.next' | translate }}</button>
        <button type="button" class="primary" *ngIf="step === 4" [disabled]="submitting || form.invalid" (click)="onFinish()">{{ 'componentsWizard.wizardV1.footer.finish' | translate }}</button>
      </ng-container>

      <!-- Fin -->
      <button type="button" class="primary" *ngIf="step === 5" (click)="onContinue()">{{ 'componentsWizard.wizardV1.footer.continue' | translate }}</button>
    </footer>
  </div>
</div>
